<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-container grid-list-md fluid>
      <v-layout row wrap fill-height>
        <v-flex xs4>
          <v-card class="fill-height">
            <v-card-title>
              <h3 class="headline mb-0">Организации</h3>
            </v-card-title>
            <v-card-text>
              <p>
                <router-link :to="{name: 'AdminOrganizationIndex'}">Список</router-link>
              </p>
              <p>
                <router-link :to="{name: 'AdminOrganizationAdd'}">Добавить</router-link>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs4>
          <v-card class="fill-height">
            <v-card-title>
              <h3 class="headline mb-0">Группы</h3>
            </v-card-title>
            <v-card-text>
              <p>
                <router-link :to="{name: 'AdminGroupIndex'}">Список</router-link>
              </p>
              <p>
                <router-link :to="{name: 'AdminGroupAdd'}">Добавить</router-link>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs4>
          <v-card class="fill-height">
            <v-card-title>
              <h3 class="headline mb-0">Вопросы</h3>
            </v-card-title>
            <v-card-text>
              <p>
                <router-link :to="{name: 'AdminQuestionsTestIndex'}">Вопросы тестирования</router-link>
              </p>
              <p>
                <router-link :to="{name: 'AdminQuestionsThematicIndex'}">Тематические вопросы</router-link>
              </p>
              <p>
                <router-link :to="{name: 'AdminQuestionsPracticeIndex'}">Практические задачи</router-link>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h3 class="headline mb-0">Ближайшие аттестации</h3>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-layout>
                <v-flex>
                  <h4>Вчера</h4>
                  <div>
                    <ol>
                      <li v-for="(group, index) in attestations.yesterday" :key="index">
                        <router-link :to="{name: 'AdminGroupView', params: {id: group.id.toString()}}">
                          {{ group.name }}
                        </router-link>
                      </li>
                    </ol>
                  </div>
                </v-flex>
                <v-flex>
                  <h4>Сегодня</h4>
                  <div>
                    <ol>
                      <li v-for="(group, index) in attestations.today" :key="index">
                        <router-link :to="{name: 'AdminGroupView', params: {id: group.id.toString()}}">
                          {{ group.name }}
                        </router-link>
                      </li>
                    </ol>
                  </div>
                </v-flex>
                <v-flex>
                  <h4>Завтра</h4>
                  <div>
                    <ol>
                      <li v-for="(group, index) in attestations.tomorrow" :key="index">
                        <router-link :to="{name: 'AdminGroupView', params: {id: group.id.toString()}}">
                          {{ group.name }}
                        </router-link>
                      </li>
                    </ol>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

import AttestationInfoService from '@/services/AttestationInfoService'
import SettingsService from '@/services/SettingsService'

export default {
  data: () => ({
    attestationInfoService: undefined,
    attestations: AttestationInfoService.getDefaultAttestations()
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle('Админка')
    }
  },
  created () {
    this.attestationInfoService = new AttestationInfoService(this.$store)
    this.attestationInfoService.getAttestationInfoList((data) => {
      this.attestations = data
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/Index.vue